<template>
  <div>
    <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
    <v-row id="analise-setorizada-nome" class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="fs-nome-analise-setorizada"
            v-model="nome"
            label="Nome da análise setorizada"
            outlined
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <div id="analise-setorizada-bdgd-versao">
      <v-row id="analise-setorizada-mes" class="mx-auto">
        <v-col id="fs-mes-dados-analise-setorizada" cols="12">
          <select-all-bdgd-versions label="Versão da BDGD" :companyId="companyId" @bdgdVersionSelected="bdgdVersionSelected" />
        </v-col>
      </v-row>
    </div>
    <div class="display-1 font-weight-normal mb-6 text-center">Selecione uma setorização para sua análise</div>
    <v-row class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            id="selecao-setorizacao"
            v-model="setorizacao.nome"
            label="Setorização"
            placeholder="Selecione uma setorização"
            readonly
            outlined
            :error-messages="errors"
            @focus.close="dialogSetorizacao = true"
          />
        </validation-provider>
      </v-col>
    </v-row>
    <v-row id="setorizacao-mapa" class="mx-auto">
      <v-col cols="12">
        <mapa-setorizacao :setorizacaoId="setorizacao.id" />
      </v-col>
    </v-row>
    <dialog-seletor-setorizacao
      :month="data"
      :items="items"
      :bdgdVersion="bdgdVersion"
      :activated.sync="dialogSetorizacao"
      @selected="setSetorizacao($event)"
    />
  </div>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'FirstTabContent',

    components: {
      SelectAllBdgdVersions: () => import('@/components/general/SelectAllBdgdVersions.vue'),
      DialogSeletorSetorizacao: () => import('@/components/general/seletores/DialogSeletorSetorizacao.vue'),
      MapaSetorizacao: () => import('@/components/analises-setorizadas/MapaSetorizacao.vue')
    },

    mixins: [dateFormatterMixins],

    props: {
      items: {
        type: Object
      }
    },

    data() {
      return {
        nome: null,
        mes: null,
        bdgdVersion: null,
        setorizacao: {
          id: null,
          nome: null
        },
        dialogSetorizacao: false
      };
    },

    computed: {
      data() {
        return this.mes ? `${this.mes}-01` : null;
      },

      companyId() {
        return this.$store.getters.getCompanyId;
      }
    },

    mounted() {
      if (this.items) this.fillInputs();
    },

    methods: {
      bdgdVersionSelected(bdgdVersion) {
        this.mes = this.formatMonthToPicker(bdgdVersion.mes);
        this.bdgdVersion = bdgdVersion.versao;
      },

      setSetorizacao(setorizacao) {
        this.setorizacao = setorizacao;
        this.dialogSetorizacao = false;
      },

      emitEventDataUpdated() {
        this.$emit('data:updated', {
          nome: this.nome,
          mes: this.mes,
          data: this.data,
          bdgdVersion: this.bdgdVersion,
          setorizacao: this.setorizacao
        });
      },

      fillInputs() {
        this.nome = this.items.nome;
        // this.mes = this.items.mes;
        // this.bdgdVersion = this.items.bdgdVersion;
        this.setorizacao = this.items.setorizacao;
      }
    },

    watch: {
      nome() {
        this.emitEventDataUpdated();
      },

      mes() {
        // this.setorizacao = { nome: null };
        this.emitEventDataUpdated();
      },

      bdgdVersion() {
        // this.setorizacao = { nome: null };
        this.emitEventDataUpdated();
      },

      setorizacao() {
        this.emitEventDataUpdated();
      }
    }
  };
</script>
